<template>
  <div data-type="input" class="input">
    <preview-image
      v-if="showImageLoader"
      :input-name="inputName"
    />

    <input
      :id="inputId"
      v-capusta-money
      type="tel"
      :size="inputSize"
      :title="inputTitle"
      :class="{ 'invalid': $v.$error }"
      :placeholder="inputPlaceholder"
      :disabled="disabled"
      :readonly="readonly"
      :maxlength="maxLength"
      :value="value"
      @change="handleInput"
      @focus="$emit('focus')"
    />

    <label :for="inputId">
      <span v-text="inputName" />
      <span v-if="isCounter(this.showCounter, this.maxLength, this.value)">
        {{ getCounter(this.maxLength, this.value) }}
      </span>
      <span
        v-if="$v.$error"
        class="validation"
        :title="getValidationInfo($v)"
      >
        <mark></mark>
      </span>
      <span v-if="readonly" class="lock">
        <mark></mark>
      </span>
      <a
        v-if="capustaInfo"
        class="hint"
        @click="$showInfo(capustaInfo)"
      ></a>
    </label>

    <slot name="link" />
  </div>
</template>

<script>
import {
  requiredIf as requiredIfValidator,
  minLength as minLengthValidator
} from 'vuelidate/lib/validators';

import {
  isCounter,
  getCounter,
  getValidationInfo
} from '@/services/inputMixins';

import PreviewImage from '@/components/inputElements/PreviewImage';

const maxLengthValidator = (maxLength) => (value) => {
  if (!value) {
    return true;
  }

  value = value.replace(/\s/g, '');

  return value.length <= maxLength;
};

const maxValueValidator = (maxValue) => (value) => {
  if (!value) {
    return true;
  }

  value = value.replace(/\s/g, '');

  return Number(value) <= Number(maxValue);
};

const minValueValidator = (minValue) => (value) => {
  if (!value) {
    return true;
  }

  value = value.replace(/\s/g, '');

  return Number(value) >= Number(minValue);
};

export default {
  name: 'InputNumber',
  mixins: [
    isCounter,
    getCounter,
    getValidationInfo,
  ],
  components: {
    PreviewImage,
  },
  props: {
    value: [Number, String],
    inputName: String,
    inputTitle: String,
    inputPlaceholder: String,
    inputId: String,
    capustaInfo: String,
    disabled: Boolean,
    readonly: Boolean,
    inputSize: { type: String, default: '12' },
    minLength: { type: Number, default: 0 },
    maxLength: { type: Number, default: 255 },
    required: { type: Boolean, default: true },
    showCounter: { type: Boolean, default: true },
    showImageLoader: { type: Boolean, default: false },
    minValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: Infinity,
    },
    onlyInteger: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$v.$touch();
  },
  validations() {
    return {
      value: {
        required: requiredIfValidator(() => this.required),
        minLength: minLengthValidator(this.minLength),
        maxLength: maxLengthValidator(this.maxLength),
        minValue: minValueValidator(this.minValue),
        maxValue: maxValueValidator(this.maxValue),
      },
    };
  },
  methods: {
    handleInput(e) {
      if (this.onlyInteger) {
        e.target.value = e.target.value.replace('.', '');
      }

      this.$emit('input', e.target.value.trim());
      this.$v.$touch();
    },
  },
};
</script>
